module.exports = __webpack_public_path__ + "regular-26970ebe589c71a565cf.svg";